export const getDataAboutSelected = (obj) => {
  let pos = -1;
  let postName = '';
  let hasAccess = false;

  if (!obj.lessons) {
    if(obj.topics.length > 0 && !obj.progress) {
      obj.topics.some((item, idx) => {
        if(item.progress) return false

        pos = obj.topics.findIndex(el => !el.progress)
        postName = item.post_name
        hasAccess = item.has_access

        return true
      })

      return {pos, postName, hasAccess}
    }

    pos = obj.topics.findIndex(el => !el.progress)
    postName = obj.post_name
    hasAccess = obj.has_access

    if(!!obj.progress && !obj.progress) {
      pos = 0
      return {pos, postName, hasAccess}
    }

    return {pos, postName, hasAccess}
  }

  Object
    .values(obj.lessons)
    .some((item, index) => {
      if (item.topics.length === 0 && !item.progress) {
        pos = (index > 0) ? pos += 2 : index
        postName = item.post_name
        hasAccess = item.has_access
        return true
      }

      const num = item.topics.findIndex(el => !el.progress)

      if (item.topics[num]) {
        pos = (index > 0) ? pos += 2 : num
        postName = item.topics[num]?.post_name
        hasAccess = item.topics[num].has_access
        return true
      }

      return false;
    }
  )

  if (postName) {
    return {pos, postName, hasAccess}
  }

  const o = Object.values(obj.lessons)[0]

  if (postName === '' && o?.topics?.length > 0) {
    const z = o.topics[0]
    postName = z.post_name
    hasAccess = z.has_access
  }

  if((postName === '' && o?.topics?.length === 0)) {
    postName = o.post_name
    hasAccess = o.has_access
  }

  return {pos, postName, hasAccess}
}
